import { useEffect, useState } from "react";
import { getLoginUrl, getSignUpUrl } from "~/lib/auth/auth";

export interface AuthState {
  isAuthenticated: boolean;
  user: { sub: string; name: string; email: string } | null;
  isLoading: boolean;
  signIn: () => void;
  signUp: () => void;
  signOut: () => void;
}

type SessionResponse = {
  isAuthenticated: boolean;
  user: { sub: string; name: string; email: string } | null;
};

export function useAuth(): AuthState {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState<{
    sub: string;
    name: string;
    email: string;
  } | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function loadSession() {
      try {
        const res = await fetch("/api/auth/session", {
          cache: "no-store",
          headers: { "Cache-Control": "no-store" },
        });
        if (!res.ok) throw new Error("session fetch failed");
        const session = (await res.json()) as SessionResponse;
        if (!cancelled) {
          setIsAuthenticated(session.isAuthenticated);
          setUser(session.user);
        }
      } catch {
        if (!cancelled) {
          setIsAuthenticated(false);
          setUser(null);
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    }

    loadSession();

    return () => {
      // eslint-disable-next-line fp/no-mutation
      cancelled = true;
    };
  }, []);

  function signIn() {
    // eslint-disable-next-line fp/no-mutation
    window.location.href = getLoginUrl(
      window.location.pathname + window.location.search,
    );
  }

  function signUp() {
    // eslint-disable-next-line fp/no-mutation
    window.location.href = getSignUpUrl(
      window.location.pathname + window.location.search,
    );
  }

  function signOut() {
    // eslint-disable-next-line fp/no-mutation
    window.location.href = "/api/auth/logout";
  }

  return { isAuthenticated, user, isLoading, signIn, signUp, signOut };
}
